import { createStore } from "redux";
import ticketBookingReducer from "./ticketBooking/ticketBookingReducer";

const store = createStore(ticketBookingReducer);

export default store;
